import '../styles.scss';
import React, { useState } from 'react';
import { Button, Popup, Icon } from 'semantic-ui-react';
import Modal from '~/components/Modal';
import { format } from 'date-fns';

interface RfiResponseItemProps {
  rfiResponse: any; // TODO create type for this
  investorName?: string;
}
const RfiResponseItem: React.FC<RfiResponseItemProps> = ({ rfiResponse, investorName }) => {

  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);

  const responseCutoff = 86;

  return (
    <div>
      <div className="fee-container">
        <p className="calculations-label">
          {rfiResponse.name}
        </p>
        <Popup position="top center"
          trigger={<Icon
            name="info circle"
            size='small'
            style={{ color: 'var(--color-charcoal)', marginBottom: 'var(--x-small)' }}
            tabIndex={0}
          />}
          content={
            <div className="rfi-response-popup-content">
              {rfiResponse.description}
            </div>
          }

        />
      </div>
      <p className="rfi-response-content">
        {rfiResponse.content ? (
            <>
            {rfiResponse.content.length > responseCutoff ? `${rfiResponse.snippet}...` : rfiResponse.snippet}
            {rfiResponse.content.length > responseCutoff && (
              <span className="text-as-button" onClick={() => setModalIsOpen(true)}>
              Read more
              </span>
            )}
            </>
        ) : (
          '-'
        )}

        <span className="rfi-response-updated-at">
          {rfiResponse.updatedAt ? `Last updated ${format(new Date(rfiResponse.updatedAt), 'MMM d, yyyy h:mm a')}` : <span style={{ opacity: 0 }}>Awaiting response...</span>}
        </span>

      </p>

      {modalIsOpen &&
        (
          <Modal closeModal={() => setModalIsOpen(false)} className="rfi-response-modal">
            <Modal.Title>
              <h2>{rfiResponse.name}</h2>
            </Modal.Title>
            <Modal.Content>
              <p className="rfi-response-description">
                {rfiResponse.description}
              </p>

              <p className="rfi-response-content">
                <strong>Response from <span>{investorName}</span>:</strong>
                <span dangerouslySetInnerHTML={{ __html: rfiResponse?.content || 'No response provided' }} />
                <span className="rfi-response-updated-at">
                  {rfiResponse.updatedAt ? `Last updated ${format(new Date(rfiResponse.updatedAt), 'MMM d, yyyy h:mm a')}` : ''}
                </span>
              </p>

            </Modal.Content>
            <Modal.Footer>
              <Button
                onClick={() => setModalIsOpen(false)}
                content='Close'
                primary
              />
            </Modal.Footer>
          </Modal>
        )}
    </div>
  );
};

export default RfiResponseItem;